import { useContext } from "react";
import { BetslipContext } from '../data/betslip/BetslipConf';
import { ASIAN_HANDICAP } from '../data/constants';
import { getBetDescription } from '../data/utils/getBetDescription';
import { getConfiguration } from '../data/utils/configuration';

function getBetdata(odd, completeBetDataSource) {
    const conf = getConfiguration();

    if (odd.value == null) {
        return;
    }
    const completeBetData = completeBetDataSource || odd.betData;
    const betData = odd.betData;
    const betId = completeBetData.cs != null ? completeBetData.cs : completeBetData.id;

    let hcp = betData.handicap;
    if (conf.nas && ASIAN_HANDICAP.includes(betData.id) && odd.id === 2) {
        hcp *= -1;
    }
    let betDesc = betData.desc;
    let oddDesc = odd.desc;
    if (betData.hideHandicap === true) {
        betDesc = betData.aggDesc;
        oddDesc = `${betData.desc} ${odd.desc}`;
    } 
    else  {
        betDesc = getBetDescription(completeBetData, false, odd.matchData.sportRef);
    }
/*else if (betData.handicap !== 0) {
        let draws = null;
        if (betData.tipoHandicap === 7) {
            draws = betData.eqs;
        }
        betDesc = parseHandicap(betData.desc, hcp, betData.tipoHandicap, draws, betData.dia);
    }*/
    const timestamp = odd.matchData.timestampDB? odd.matchData.timestampDB : odd.matchData.timestamp;
    
    return {
        pal: odd.matchData.pal,
        avv: odd.matchData.avv,
        alias: odd.matchData.alias,
        matchDesc: odd.matchData.desc,
        isLive: betData.isLive,
        betId: betId,
        handicap: betData.handicap,
        betDesc: betDesc,
        id: odd.id,
        desc: oddDesc,
        value: odd.rawValue,
        legabile: betData.legabile,
        sportDesc: odd.matchData.sportDesc,
        tournamentDesc: odd.matchData.tournamentDesc,
        timestamp: timestamp,
        sportRef: odd.matchData.sportRef,
        tournamentRef: odd.matchData.tournamentRef,
        maxg : betData.maxg,
        ming : betData.ming
    };
}

export default function useBetslip(props) {
    const betslipContext = useContext(BetslipContext);

    function addBet(e, completeBetData) {
        e.preventDefault();
        e.stopPropagation();
        
        const betData = getBetdata(props, completeBetData);
        if (betData == null) {
            return;
        }
        let matchData = null;
        if(props.matchData){
        	matchData = {
        		alias : props.matchData.alias,
        		avv : props.matchData.avv,
        		desc : props.matchData.desc,
        		id : props.matchData.id,
        		isLive : props.matchData.isLive,
        		pal : props.matchData.pal,
        		seoSettings : props.matchData.seoSettings,
        		seoSettingsAdds : props.matchData.seoSettingsAdds,
        		sportDesc : props.matchData.sportDesc,
        		sportRef : props.matchData.sportRef,
        		timestamp : props.matchData.timestamp,
        		tournamentDesc : props.matchData.tournamentDesc,
        		uniqueId : props.matchData.uniqueId,
        		urlPath : props.matchData.urlPath,
        		urlPathSeo : props.matchData.urlPathSeo,
        		urlPathSeoSettings : props.matchData.urlPathSeoSettings
        	};
        }
        betslipContext.toggleSelectionBetslip(betData.pal,
                                              betData.avv,
                                              betData.alias,
                                              betData.matchDesc,
                                              betData.isLive,
                                              betData.betId,
                                              betData.handicap,
                                              betData.betDesc,
                                              betData.id,
                                              betData.desc,
                                              betData.value,
                                              betData.legabile,
                                              betData.sportDesc,
                                              betData.tournamentDesc,
                                              betData.timestamp,
                                              betData.sportRef,
                                              betData.tournamentRef,
                                              betData.ming,
                                              betData.maxg,
                                              matchData,
                                              props.isBetBuilder);
    }

    const selected = props.isBetBuilder? betslipContext.isBetBuilderDrawSelected(props.matchData.pal, props.matchData.avv, props.betData.id, props.betData.handicap, props.id) : betslipContext.isDrawSelected(props.matchData.pal, props.matchData.avv, props.betData.id, props.betData.handicap, props.id);

    return [addBet, selected];
}
